/* eslint-disable react/jsx-one-expression-per-line, react/no-unescaped-entities, react/jsx-indent, max-len */
import React from 'react';
import { Constants } from 'relevant-shared/dfp/dfpGranularityAdsState';

const Snippets = {
	reportDocs: (
		<>
			<p>
				The order which <b>Google Ad Manager</b> reports will be pulled when
				synchronizing Adx CPM data to HBA reports - from first to last.
				In addition, these reports will also be split by Ad Unit and Date/Hour.
			</p>
			<p><br /></p>
			<p>
				Because of reporting limitations, an <i>approximated</i> maximum number of report rows per
				ad unit and hour is calulated. This number is not allowed to
				exceed <b>{Constants.MAX_COMBOS_PER_REPORT_UNIT}</b> such combinations.
			</p>
			<p><br /></p>
			<p>
				If this happens and <b>Approximated max report rows per ad unit</b> shows a too high value, <i>the solution
				is to choose a different</i> <b>Custom Dimension Key</b> for one/some of the dimension(s) in order to split the
				data points into other/new GAM reports.
			</p>
			<p><br /></p>
			<p>
				<b>NOTICE:</b> The precision of the Adx CPM data increases from the first to last reports, where only
				the dimensions in the last reports will correspond exactly to the Adx CPM. This means for example that,
				as <b>Browser</b> is in the last report - the <b>eCPM</b> of Google + OpenRTB (Adx) for browser "Chrome"
				in HBA reports should be identical to <b>Ad Exchange average eCPM</b> in GAM reports per ad unit and hour.
				On the other hand, there might be slight discrepancies when doing a similar comparison by <b>Country</b>,
				as that dimension is in the second-to-last report.
			</p>

		</>
	)
};

export default Snippets;
